import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { teamKeys } from "@/lib/query-keys";
import type { Team, TeamMemberRef } from "@/types/domain";

/**
 * El equipo de la organización. `isTeam` es false en cuentas individuales, y es lo
 * que usan las pantallas para decidir si renderizan el toggle del equipo, el
 * responsable y "Mi equipo".
 */
export function useTeam(enabled = true) {
  return useQuery({
    queryKey: teamKeys.all,
    enabled,
    // El equipo cambia con altas manuales, no durante la sesión.
    staleTime: 5 * 60 * 1000,
    queryFn: () => fetchToBackend<Team>("/organization/team"),
  });
}

/**
 * Un miembro por id, en la forma que consumen el avatar y el selector. El listado
 * de licitaciones solo trae `assignedUserId`: el nombre y la foto salen de acá, que
 * es una sola consulta cacheada para toda la pantalla.
 */
export function useTeamMember(userId?: string | null): TeamMemberRef | null {
  const { data: team } = useTeam();
  if (!userId) return null;
  const member = team?.members.find((m) => m.userId === userId);
  return member
    ? { id: member.userId, name: member.name, image: member.image }
    : null;
}
